<template>
  <div>
    <list
      row-key="AccountId"
      ref="list"
      unit="账号"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="账号名称">
          <el-input v-model="params.AccountName" placeholder="请输入账号名称" clearable />
        </el-form-item>
        <el-form-item label="状态" v-if="!IsSelect">
          <el-select v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="AccountCode" label="账号编号" min-width="120px" />
        <el-table-column prop="AccountName" label="账号名称" min-width="120px" />
        <el-table-column prop="ClassName" label="账号类别" min-width="120px" />
        <el-table-column prop="AccountType" label="账号类型" min-width="100px" />
        <el-table-column prop="Bank" label="开户银行" min-width="120px" />
        <el-table-column prop="AccountNumber" label="银行账号" min-width="200px" />
        <el-table-column prop="Balance" label="当前余额" min-width="120px" v-if="!IsSelect" />
        <!-- <el-table-column prop="Sn" label="序号" min-width="50px" /> -->
        <el-table-column prop="Status" label="状态" align="center" width="70" v-if="!IsSelect">
          <template slot-scope="{row}">
            <el-tag type="danger" v-if="row.Status==0">停用</el-tag>
            <el-tag type="warning" v-if="row.Status==1">启用</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    IsSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require("@/api/sale/account").default,
      params: {
        AccountName: "",
        Status: null,
      },
    };
  },
  methods: {
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>